import React from "react";
import AppState from "./AppState";

export const AppContext = React.createContext(new AppState());
